export default "__VITE_ASSET__C7iTR4SG__"